/* eslint-disable import/prefer-default-export */
import LocalStorageComponent from './components/LocalStorageComponent.react';

export {
   LocalStorageComponent
};



// WEBPACK FOOTER //
// ./index.js